<template lang="pug">
#sub-empresa-bloco-pesquisa-filtros
    .filtros
        .bloco-pesquisa-filtros__container
            .bloco-pesquisa-filtros__barra-pesquisa
                i.el-icon-search
                input(
                    v-model='pesquisa',
                    type='text',
                    :placeholder='$t("denuncia.words.filter_title")',
                    autocomplete='off',
                    v-mask='mask',
                    @keyup.enter='aplicarFiltros',
                    @input='e => updateMask(e.target.value)'
                )

        .filtros-data
            el-date-picker.input-data-cadastro(
                v-model='dataSelecionada',
                type='daterange',
                range-separator='-',
                clearable,
                editable,
                format='dd/MM/yyyy',
                :start-placeholder='$t("mensagens.subEmpresaGestao.placehoder.dataInicio")',
                :end-placeholder='$t("mensagens.subEmpresaGestao.placehoder.dataFim")',
                size='large',
                @change='aplicarFiltros'
            )
</template>

<script>
export default {
    name: 'DenunciaBlocoPesquisaFiltros',
    data() {
        return {
            collapse: null,
            tags: [],
            dataSelecionada: '',
            pesquisa: '',
            mask: ''
        };
    },
    methods: {
        updateMask(value) {
            if (this.pesquisa === '') this.aplicarFiltros();
            if (isNaN(value[0])) {
                this.mask = 'XX-XXXXXXX-XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX';
                this.pesquisa = this.pesquisa.toUpperCase();
            } else {
                const valueCleaned = value.replace(/\D/g, '');

                if (valueCleaned.length <= 10) {
                    this.mask = '##########';
                } else if (valueCleaned.length === 11) {
                    this.mask = '###.###.###-##';
                } else {
                    this.mask = '##.###.###/####-##';
                }
            }
        },
        aplicarFiltros() {
            const dataSelecionada = this.dataSelecionada || '';
            const dataCadastroInicio = dataSelecionada
                ? this.converterData(dataSelecionada[0])
                : '';
            const dataCadastroFim = dataSelecionada
                ? this.converterData(dataSelecionada[1])
                : '';
            const pesquisa = this.pesquisa || '';
            const filtro = {
                dataCadastroInicio,
                dataCadastroFim,
                pesquisa
            };
            this.tags = [];
            if (dataSelecionada) this.tags.push('Data da denuncia');
            this.$emit('emitFiltros', filtro);
        },
        converterData(value) {
            const date = new Date(value);

            return date.toISOString().split('.')[0];
        },
        limparFiltros() {
            this.tags = [];
            this.dataSelecionada = '';
            this.pesquisa = '';
            this.aplicarFiltros();
        },

        removerFiltro(filtro) {
            this.tags.splice(this.tags.indexOf(filtro), 1);
            this.desmarcarFiltroPopover(filtro);
            this.aplicarFiltros();
        },

        desmarcarFiltroPopover(filtro) {
            if (filtro === 'Data do denuncia') {
                this.dataSelecionada = '';
            }
        }
    }
};
</script>

<style lang="scss">
body {
    overflow-y: hidden;
    overflow-x: hidden;
}

.filtros {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    gap: 10px;
}

.bloco-pesquisa-filtros__container {
    width: 100%;
    height: 42px;
    border-radius: 5px;
    background: var(--white);
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    position: relative;
}

.filtros-data {
    box-shadow: 0px 0px 10px rgb(0 0 0 / 10%);
}

.input-data-cadastro {
    height: 43px !important;

    .el-input__inner {
        height: 43px !important;
    }
}

.bloco-pesquisa-filtros__barra-pesquisa {
    height: 100%;
    display: flex;
    justify-content: center;

    i.el-icon-search {
        color: var(--gray);
        font-size: 16px;
        display: flex;
        align-items: center;
        margin: 0 8px;
    }

    input {
        width: 100%;
        height: 100%;
        border: none;
        outline: none;
        border-radius: 5px;
        color: var(--primary);
    }
}

.bloco-pesquisa-filtros__filtros-selecionados {
    display: flex;
    align-items: center;
    gap: 4px;
    flex-wrap: wrap;
}

.filtros-selecionados__limpar {
    cursor: pointer;
}

.filtros-avancados__titulo {
    color: var(--primary);
    font-weight: bold;
}

.filtros-avancados__opcoes {
    font-size: 0;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
}
</style>
